import React, { useState, useEffect } from "react";
import { Modal, Table, Input, Pagination, Tag, Button, Space, Typography, DatePicker } from "antd";
import { CiSearch} from "react-icons/ci";
import { MdOutlineContentPasteSearch} from "react-icons/md";
import axios from "axios";
import { Base_Uri } from "../../../Constant/BaseUri";
import dayjs from "dayjs";

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const InvoiceSelectorModal = ({ visible, onCancel, onSelect }) => {
  const [invoices, setInvoices] = useState([]);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
    const [dateRange, setDateRange] = useState([]);

  // ✅ Fetch invoices
  const fetchInvoices = async (page = 1, pageSize = 10, searchValue = "") => {
    setLoading(true);
    try {
      const [startDate, endDate] = dateRange;
      const { data: res } = await axios.get(`${Base_Uri}getInvoiceWithFilter`, {
        params: { page, limit: pageSize, search: searchValue,startDate: startDate ? dayjs(startDate).startOf("day").toISOString() : null,
        endDate: endDate ? dayjs(endDate).endOf("day").toISOString() : null, },
      });

      if (res.status) {
        setInvoices(res.data);
        setPagination({
          current: page,
          pageSize,
          total: res.pagination.total,
        });
      }
    } catch (err) {
      console.error("Error fetching invoices:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      fetchInvoices(1, pagination.pageSize, search);
    }
  }, [visible,dateRange]);

  // ✅ Handle search
  const handleSearch = (value) => {
    setSearch(value);
    fetchInvoices(1, pagination.pageSize, value);
  };

  // ✅ Handle pagination
  const handleTableChange = (page, pageSize) => {
    fetchInvoices(page, pageSize, search);
  };

  // ✅ Columns
  const columns = [
    {
      title: "Invoice #",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Business Name",
      dataIndex: "customerName",
      key: "customerName",
      render: (text,{customerDetails}) => (customerDetails?.[0]?.businessName ? customerDetails?.[0]?.businessName : <Text type="secondary">No Name</Text>),
    },
    {
      title: "Date",
      dataIndex: "saleDate",
      key: "saleDate",
      render: (date) => (
        <Tag color="blue">{new Date(date).toLocaleDateString()}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => onSelect(record)}
        >
          Select
        </Button>
      ),
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      centered
      width={850}
      style={{zIndex:2000}}
      title={
        <Space align="center">
          <MdOutlineContentPasteSearch  style={{ color: "#1677ff", fontSize: 20 }} />
          <Title level={4} style={{ margin: 0 }}>
            Select Invoice
          </Title>
         
        </Space>
      }
      bodyStyle={{
        background: "#f8f9fa",
        borderRadius: 8,
        padding: 16,
      }}
    >
      {/* Search bar */}
       <div style={{fontSize:16,color:"#6e6e6e",marginBottom:10}}>
            Returned or exchanged products from invoices are not displayed here. Return and exchange invoices are also excluded from this list.
          </div>
      <Input
        prefix={<CiSearch />}
        placeholder="Search by invoice number, business name, customer name..."
        allowClear
        onChange={(e) => handleSearch(e.target.value)}
        value={search}
        style={{
          marginBottom: 16,
          borderRadius: 8,
          padding: "8px 12px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      />

      <RangePicker
      allowClear
          value={dateRange}
          onChange={(values) => setDateRange(values || [])}
          format="YYYY-MM-DD"
        />

      {/* Data Table */}
      <Table
        columns={columns}
        dataSource={invoices}
        loading={loading}
        rowKey="_id"
        pagination={false}
        bordered
        size="middle"
        style={{ background: "white", borderRadius: 8 }}
      />

      {/* Pagination */}
      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          showSizeChanger
          showTotal={(total) => `Total ${total} invoices`}
          onChange={handleTableChange}
        />
      </div>
    </Modal>
  );
};

export default InvoiceSelectorModal;
